import { apiFetch } from './client';

export interface DashboardSummary {
  calls_today: number;
  calls_this_month: number;
  /** Currently in-progress calls. Scoped per role by RLS:
   *  super_admin sees platform-wide, reseller_owner sees their reseller,
   *  office_manager + lower see their customer. */
  calls_live: number;
  voicemails_unread: number;
  orders_open: number;
  enrollments_active: number;
  forum_pending: number;
  sms_today_outbound: number;
  sms_today_inbound: number;
  callers_total: number;
}

export interface RecentActivityItem {
  kind: 'call' | 'voicemail' | 'sms' | 'order' | 'enrollment';
  id: string;
  label: string;
  created_at: string;
  meta?: Record<string, unknown>;
}

export const dashboard = {
  summary: () => apiFetch<DashboardSummary>('/api/dashboard/summary'),
  activity: () => apiFetch<{ rows: RecentActivityItem[] }>('/api/dashboard/activity'),
};
